export default {
  procesarErrores(errors) {
    const errorMessages = [];
    /* eslint-disable no-prototype-builtins */
    for (const key in errors) {
      if (errors.hasOwnProperty(key)) {
        errorMessages.push(`<li>${errors[key]}</li>`);
      }
    }
    return `
      <ul style="list-style-type:none; padding-left:0;">
        ${errorMessages.join('')}
      </ul>
    `;
  },
};
